import { cx } from '@emotion/css';
import { CircularProgress, Grid, Typography } from '@mui/material';
import { SimpleShowLayout, useGetOne, useRecordContext } from 'react-admin';
import { DataProviderResource } from 'src/constants';
import { Account, AccountApplication } from 'src/models';
import { BaseLayout, Spacing } from 'src/styles';

import { ApplicationCategory } from './ApplicationCategory';

export const ApplicationShow = () => {
  const { id, applicationId, entityAccountType } = useRecordContext<Account>();

  const { data, isLoading, error } = useGetOne<AccountApplication>(DataProviderResource.AccountApplication, {
    id: applicationId ?? '',
    meta: { accountId: id },
  });

  if (error) return <div>Unknown error occurred. Received: {JSON.stringify(error)} </div>;

  if (isLoading) {
    return (
      <div className='alignAllCenter'>
        <CircularProgress />
      </div>
    );
  }

  return (
    <Grid container>
      <Grid item md={12}>
        <SimpleShowLayout>
          <Typography variant='h5'>Application Categories</Typography>
        </SimpleShowLayout>
      </Grid>
      {data?.categories.map(category => (
        <Grid item md={12} key={category.name.value} className={cx(BaseLayout.card, Spacing.my16)}>
          <ApplicationCategory
            category={category}
            applicationId={applicationId}
            accountId={id}
            entityAccountType={entityAccountType}
          />
        </Grid>
      ))}
    </Grid>
  );
};
